import React, { useState } from 'react';
import { FaWhatsapp, FaTimes, FaCommentDots } from 'react-icons/fa';
import { useLanguageContext } from '../../context/language_context';
import Wrapper from './styles';

const WhatsAppButton = () => {
  const { isArabic } = useLanguageContext();
  const [isOpen, setIsOpen] = useState(false);
  const phoneNumber = '21624967414';

  const whatsappUrl = `https://wa.me/${phoneNumber}`;

  const labelText = isArabic ? 'دعم واتساب' : 'WhatsApp Support';
  const headingText = isArabic
    ? 'فريق دعم الواتساب على مدار 24 ساعة'
    : 'WhatsApp support team available 24/7';
  const ctaText = isArabic ? 'دعم واتساب' : 'WhatsApp Support';
  const welcomeText = isArabic
    ? 'كيفاش نجمو نعاونوك؟'
    : 'How can we help you?';

  return (
    <Wrapper $isArabic={isArabic}>
      {/* Chat popup */}
      {isOpen && (
        <div className='chat-popup'>
          <div className='chat-header'>
            <FaCommentDots className='chat-icon' />
          </div>
          <div className='chat-body'>
            <p className='chat-heading'>{headingText}</p>
            <p className='chat-welcome'>{welcomeText}</p>
            <a
              href={whatsappUrl}
              target='_blank'
              rel='noopener noreferrer'
              className='chat-cta'
            >
              <FaWhatsapp className='cta-icon' />
              <span>{ctaText}</span>
              <span className='cta-arrow'>{isArabic ? '\u003E' : '\u003E'}</span>
            </a>
          </div>
        </div>
      )}

      {/* Button + Label container */}
      <div className='whatsapp-container'>
        {/* Label bubble */}
        {!isOpen && (
          <div className='label-bubble' onClick={() => setIsOpen(true)}>
            <span>{labelText}</span>
            <button
              className='label-close'
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              &times;
            </button>
          </div>
        )}

        {/* Main floating button */}
        <button
          className='whatsapp-btn'
          onClick={() => setIsOpen(!isOpen)}
          aria-label={isArabic ? 'تواصل معنا على واتساب' : 'Contact us on WhatsApp'}
        >
          {isOpen ? (
            <FaTimes className='whatsapp-icon' />
          ) : (
            <FaWhatsapp className='whatsapp-icon' />
          )}
        </button>
      </div>
    </Wrapper>
  );
};

export default WhatsAppButton;
